import gql from 'graphql-tag';

export const audioPlaylistQuery = gql`
  query ($slug: ID!) {
    audioPlaylist(id: $slug, idType: SLUG) {
      content
      databaseId
      duration
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      imageSrcset
      scCreatedAt
      tags {
        nodes {
          name
          slug
        }
      }
      title
      tracks {
        content
        duration
        featuredImage {
          altText
          sourceUrl
        }
        imageSrcset
        fileUrl
        scApiUrl
        slug
        title
        trackId
      }
      __typename
    }
  }
`;
